import React, { useState } from 'react';
import { useTable, useFilters, usePagination, useSortBy, useFlexLayout } from 'react-table';
import columns from './Columns';
import './RiskTable.css'; // Import the CSS file

import SortDown from "../../assets/images/sortdown.svg";
import SortUp from "../../assets/images/sortup.svg";





const IncidentsTable = ({ data, openpopup }) => {
    /* const [filterInput, setFilterInput] = useState({
         Department: '',
         Owner: '',
         Status: ''
     });
     */

    const defaultColumn = React.useMemo(
        () => ({
            Filter: ''
        }),
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        //canPreviousPage,
        //canNextPage,
        //pageOptions,

        //nextPage,
        //previousPage,
        //setFilter,
        //rows,
        page,
        setPageSize,
        pageSize,
        pageCount,
        gotoPage,
        state: { pageIndex }
    } = useTable(
        {
            columns,
            data,
            defaultColumn,
            initialState: { pageIndex: 0 }
        },
        useFilters,
        useSortBy,
        usePagination,


    );



    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(pageCount);

    React.useEffect(() => {
        setTotalPages(pageCount);
        setCurrentPage(pageIndex + 1);
    }, [pageCount, pageIndex]);




    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            ////console.log(newPage);
            setCurrentPage(newPage);
            gotoPage(newPage - 1);
        }
    };



return (
  <div className="incidents">          {/* <-- scoped wrapper */}
    <div className="table-container2 ml-8">
      <table {...getTableProps()} className="main-table2">
        <thead style={{ height: 56 }}>
          {headerGroups.map(hg => (
            <tr {...hg.getHeaderGroupProps()}>
              {hg.headers.map(col => {
                if (col.dontshow) return null;
                return (
                  <th {...col.getHeaderProps(col.getSortByToggleProps())}>
                    <div className="flex items-center">
                      {col.render('Header')}
                      <span className="sort-icon">
                        {col.isSorted
                          ? (col.isSortedDesc
                              ? <img src={SortDown} alt="Sort Down" />
                              : <img src={SortUp} alt="Sort Up" />)
                          : null}
                      </span>
                    </div>
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map(row => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  if (cell.column.dontshow) return null;
                  return (
                    <td {...cell.getCellProps()} className="cursor-pointer">
                      {cell.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
);



};

export default IncidentsTable;